import { React, useEffect, useState } from "react";
import { Layout, Row, Col, Form, Input, Button, Checkbox } from "antd";
import {
  FullHeightRow,
  AuthLeftContainer,
  HaberForm,
  AuthTitleBlock,
} from "../styledElements";
import AuthRightContainer from "../../Components/AuthRightBox/authRightContainer";
import AlertContainer from "../../Components/AlertBoxes/alertBox";
import Logo from "../../Assets/Images/logo.svg";
import { Link, useLocation, useNavigate } from "react-router-dom";

const validateMessages = {
  required: "This field is required!",
  types: {
    email: "Not a valid email format!",
  },
};

const ResetVerification = (props) => {
  const location = useLocation();
  const navigate = useNavigate();
  const [userEmail, setUserEmail] = useState(location.state.email);
  const [verificationCode,setVerificationCode]=useState()

  const onFinish = (values) => {
    if (values) {
      navigate(
        "/change-password",
        { state: { userEmail: userEmail, code: verificationCode } },
        { replace: true }
      );
    }
  };

  return (
    <>
      <FullHeightRow>
        <Layout className="authLayout" style={{ backgroundColor: "#ffffff" }}>
          <Row span={24}>
            <Col span={12} className="colLayoutBlock">
              <AuthLeftContainer>
                <div className="flexBlock" style={{ justifyContent: "center" }}>
                  <div className="vCenterBlock">
                    <div className="hCenterBox">
                      <AuthTitleBlock>
                        <div className="logo">
                          <img src={Logo} alt="HaberERP" />
                        </div>
                        <h1>See HaberERP in action</h1>
                        <p>
                          See how HaberERP can optimize your trim losses and
                          reduce costs in paper production
                        </p>
                      </AuthTitleBlock>
                      <HaberForm>
                        <Form
                          name="basic"
                          autoComplete="off"
                          className="haberLogin"
                          validateMessages={validateMessages}
                          onFinish={onFinish}
                        >
                          <Form.Item
                            name="username"
                            rules={[{ required: true, type: "email" }]}
                            className="mailIcon"
                            initialValue={userEmail}
                          >
                            <Input placeholder="Enter your email" disabled />
                          </Form.Item>

                          <Form.Item
                            name="verificationCode"
                            rules={[{ required: true }]}
                            className="lockIcon"
                            
                          >
                            <Input.Password onChange={(event)=>setVerificationCode(event.target.value)} placeholder="Enter verification code" />
                          </Form.Item>
                          <Form.Item>
                            <Button
                              type="primary"
                              htmlType="submit"
                              className="btnSubmit"
                            >
                              {" "}
                              Reset your password{" "}
                            </Button>
                          </Form.Item>
                        </Form>
                        <div className="pageLinks">
                          <Link to="/privacy-policy">Privacy Policy</Link> |{" "}
                          <Link to="/terms-and-conditions">
                            Terms & Conditions
                          </Link>
                        </div>
                      </HaberForm>
                    </div>
                  </div>
                </div>
              </AuthLeftContainer>
            </Col>
            <Col span={12} className="colLayoutBlock">
              <AuthRightContainer />
            </Col>
          </Row>
        </Layout>
      </FullHeightRow>
    </>
  );
};

export default ResetVerification;
